module.exports = __webpack_public_path__ + "img/markers_default@2x.0e04541.png";


//////////////////
// WEBPACK FOOTER
// ./public/pages/index/assets/img/markers_default@2x.png
// module id = 172
// module chunks = 0